import { Button, Modal, Select } from "antd";
import { memo } from "react";
import {
  PaymentStatus,
  PaymentStatusLabel,
  ShippingStatus,
  ShippingStatusLabel,
} from "../../../enum/lisence";
import closeModal from "../../../images/close-modal-icon.png";

const UpdatePaymentModal = memo(function UpdatePaymentModal({
  isModalOpen,
  handleOk,
  handleCancel,
  state,
  setState,
  shipping,
  setShipping,
}: {
  isModalOpen: boolean;
  handleOk:
    | ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  handleCancel:
    | ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  state: string | null;
  setState: (e: string) => void;
  shipping: string | null;
  setShipping: (e: string) => void;
}) {
  return (
    <Modal
      className="custom-modal"
      title="ステータス更新"
      closeIcon={<img src={closeModal} alt="close icon" className="w-6" />}
      closable={{ "aria-label": "Custom Close Button" }}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={(_) => (
        <div className="flex gap-2 justify-between">
          <Button
            className="text-base font-medium h-[52px] flex-1"
            onClick={handleCancel}
          >
            キャンセル
          </Button>
          <Button
            className="h-[52px] flex-1 base-button"
            onClick={handleOk}
            disabled={!state && !shipping}
          >
            保存
          </Button>
        </div>
      )}
    >
      <div className="mb-2">
        <div className="flex gap-2 items-center mb-[6px]">
          <p className="mb-0 text-sm font-semibold">決済ステータス</p>
        </div>
        <Select
          placeholder="お支払いの状態を選択してください"
          style={{ width: "100%", height: "46px" }}
          onChange={setState}
          value={state}
          options={[
            { value: PaymentStatus.PAID, label: PaymentStatusLabel.paid },
            { value: PaymentStatus.UNPAID, label: PaymentStatusLabel.unpaid },
          ]}
        />
      </div>
      <div>
        <div className="flex gap-2 items-center mb-[6px]">
          <p className="mb-0 text-sm font-semibold">出荷可否ステータス</p>
        </div>
        <Select
          placeholder="出荷可否の状態を選択してください"
          style={{ width: "100%", height: "46px" }}
          onChange={setShipping}
          value={shipping}
          options={[
            {
              value: ShippingStatus.SHIPPED,
              label: ShippingStatusLabel.shipped,
            },
            {
              value: ShippingStatus.NOT_SHIPPED,
              label: ShippingStatusLabel.not_shipped,
            },
          ]}
        />
      </div>
    </Modal>
  );
});

export default UpdatePaymentModal;
